import React from 'react'
import _ from 'lodash'
import { FieldArray } from 'formik'
import Row from './Row/index'
import AddCustom from './AddCustom'

export default ({
  baseName,
  form: {
    values,
  },
  form,
  withCustom,
  ...rest,
}) => (
  <div>
    <FieldArray name={baseName} render={(arrayHelpers) => (
      <>
        {_.map(_.get(values, baseName), (row, index) => (
          <Row
            key={index}
            baseName={`${baseName}[${index}]`}
            noTopLine={index === 0}
            form={form}
            arrayHelpers={arrayHelpers}
            index={index}
            {...row}
            {...rest}
          />
        ))}

        {withCustom && <AddCustom {...arrayHelpers} />}
      </>
    )} />
  </div>
)
